<div class="card squirrel-card">
    <div class="card-body">
        <div class="row">
            <div class="col-md-8">
                <!-- <button matTooltip="{{this.translate.data['ADDTENANTPROJECTGROUPROLE'] | translate}}"
                 mat-button matSuffix mat-icon-button (click)="addProjectGroupRole()">
                    <mat-icon>add</mat-icon>
                </button> -->
                <a>
                    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 0px;margin-left: 0px" matTooltip="{{this.translate.data['ADDTENANTPROJECTGROUPROLE'] | translate}}" (click)="addProjectGroupRole()">Neue Rolle</button>
                </a>
            <!-- <form [formGroup]="projectGroupRoleForm" novalidate>
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['INPUTENTERPROJECTGROUPROLE'] | translate}}"
                            formControlName="name" required>
                        <button mat-button matSuffix mat-icon-button (click)="addProjectGroupRole()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </mat-form-field>
                </form> -->
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 project-group-role-board-body-table">
                <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                    <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                    <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                        Squirrel's API rate limit has been reached. It will be reset in one minute.
                    </div>
                </div>
                <ag-grid-angular class="ag-theme-balham" style="width:100%; height:calc(100vh - 500px);" 
                    [overlayLoadingTemplate]="overlayLoadingTemplate"
                    [gridOptions]="gridOptions"
                    (gridReady)="onGridReady($event)" 
                    [frameworkComponents]="frameworkComponents">
                </ag-grid-angular>
            </div>
        </div>
        <div class="row">
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 15px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
            (click)="cancel()" >Abbruch</button>
        </div>
    </div>
</div>